import React from 'react'
import { Box, Drawer, Icon, IconButton, Select, ToggleButton, Typography } from '@mui/material'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import ClearIcon from '@mui/icons-material/Clear'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AdxButton from 'components/custom/AdxButton'

const MobileJobBoardFilterDrawer = ({
  backgroundData,
  backgroundFilter,
  cityDataArray,
  cityFilter,
  handleCityChange,
  handleBackgroundChange,
  allJobBoardisError,
  setCityFilter,
  setBackgroundFilter,
  typeFilter,
  handleCheckboxChange,
  handleSearchJobsButton,
  drawerState,
  handleDrawer,
}) => {
  const handleCallBack = (state) => {
    handleDrawer(state)
  }

  return (
    <>
      <Box
        onClick={() => handleCallBack(true)}
        sx={{
          border: 1,
          borderRadius: '4.5px',
          padding: '12px 14px',
          borderColor: '#8A8A8A',
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
        }}
      >
        <Icon sx={{ color: 'alternate.main', fontSize: '20px' }}>tune</Icon>
        <Typography>Filter</Typography>
      </Box>
      <Drawer
        PaperProps={{
          sx: {
            borderRadius: '4.5px 4.5px 0px 0px',
          },
        }}
        anchor="bottom"
        open={drawerState}
        onClose={() => handleCallBack(false)}
      >
        <Box
          sx={{
            width: '100vw',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                marginBottom: '32px',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="h3" fontFamily={'Oswald'}>
                  Filter
                </Typography>
                <Icon onClick={() => handleCallBack(false)}>clear</Icon>
              </Box>
              <Typography>Choose and apply from the filter below.</Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Select
                  disabled={allJobBoardisError}
                  value={cityFilter?.value ?? {}}
                  onChange={handleCityChange}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    height: '45px',
                    width: '100%',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                  renderValue={(params) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      {!cityFilter && (
                        <PlaceOutlinedIcon
                          sx={{
                            color: allJobBoardisError ? 'gray-line.main' : 'alternate.main',
                          }}
                        />
                      )}
                      <Typography
                        variant="subtitle1"
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: cityFilter ? 'dark-text.main' : 'light-gray-text.main',
                        }}
                      >
                        {cityFilter ?? 'All cities'}
                      </Typography>
                    </Box>
                  )}
                  IconComponent={
                    cityFilter === null
                      ? ExpandMoreIcon
                      : () => (
                          <IconButton onClick={() => setCityFilter(null)}>
                            <ClearIcon />
                          </IconButton>
                        )
                  }
                >
                  {cityDataArray?.map((city, index) => (
                    <AdxMenuItem
                      key={index}
                      sx={{ margin: 1, borderRadius: '4.5px' }}
                      value={city?.value}
                      selectedvalue={cityFilter}
                    >
                      {city?.value}
                    </AdxMenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={{ width: '100%' }}>
                <Select
                  disabled={allJobBoardisError}
                  value={backgroundFilter ?? {}}
                  onChange={handleBackgroundChange}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    height: '45px',
                    width: '100%',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                  renderValue={(params) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: backgroundFilter ? 'dark-text.main' : 'light-gray-text.main',
                        }}
                      >
                        {backgroundFilter?.job_background_name ?? 'All backgrounds'}
                      </Typography>
                    </Box>
                  )}
                  IconComponent={
                    backgroundFilter === null
                      ? ExpandMoreIcon
                      : () => (
                          <IconButton onClick={() => setBackgroundFilter(null)}>
                            <ClearIcon />
                          </IconButton>
                        )
                  }
                >
                  {backgroundData?.map((background, index) => (
                    <AdxMenuItem
                      key={index}
                      sx={{ margin: 1, borderRadius: '4.5px' }}
                      value={background}
                      selectedvalue={backgroundFilter}
                    >
                      {background?.job_background_name}
                    </AdxMenuItem>
                  ))}
                </Select>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '16px',
                  marginTop: '8px',
                }}
              >
                {typeFilter?.map((item, index) => (
                  <ToggleButton
                    key={index}
                    value={item?.value}
                    selected={item?.checked}
                    onChange={() => handleCheckboxChange(index)}
                    sx={{
                      width: '100%',
                      border: 'none',
                      '&.Mui-selected': {
                        backgroundColor: 'alternate.light',
                      },
                      '&:not(.Mui-selected)': {
                        backgroundColor: 'gray-background.main',
                      },
                      '&:hover': {
                        '&.Mui-selected': {
                          backgroundColor: 'alternate.light',
                        },
                        '&:not(.Mui-selected)': {
                          backgroundColor: 'gray-background.main',
                        },
                      },
                    }}
                  >
                    <Typography
                      sx={{ color: item?.checked ? 'alternate.main' : 'light-gray-text.main' }}
                    >
                      {item?.name}
                    </Typography>
                  </ToggleButton>
                ))}
              </Box>
            </Box>
          </Box>
          <Box sx={{ alignSelf: 'flex-end', width: '100%', marginTop: '64px' }}>
            <AdxButton
              variant={'contained'}
              onClick={() => {
                handleSearchJobsButton()
                handleCallBack(false)
              }}
              sx={{ boxShadow: 'none', width: '100%' }}
            >
              Show results
            </AdxButton>
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default MobileJobBoardFilterDrawer
